// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"EI6YT","title":"PzYcY","headingMargin":"YhsI8","subtitle":"cPKNr","searchModule":"dYRKf","numberOfResults":"YAPsq"};